var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-actions',{staticClass:"text-right"},[_c('v-btn',{attrs:{"color":"primary","loading":_vm.loadingDocx,"disabled":_vm.disableUpload},on:{"click":_vm.exportDocx}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-download ")]),_vm._v(" Выгрузить заключение метод. кач. (.docx) ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }